import axios from 'axios';

// Single axios instance for every call to the Django API.
// REACT_APP_API_URL is empty in production (same-origin /api behind nginx)
// and e.g. http://localhost:7000 for local development.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
});

const AUTH_PATHS = ['/api/token/', '/api/token/refresh/'];
const isAuthCall = (url = '') => AUTH_PATHS.some((p) => url.includes(p));

api.interceptors.request.use((config) => {
  const access = localStorage.getItem('access');
  if (access && !config.headers.Authorization && !isAuthCall(config.url)) {
    config.headers.Authorization = `Bearer ${access}`;
  }
  return config;
});

// One in-flight refresh shared by all requests that hit a 401 together.
let refreshPromise = null;

const refreshAccessToken = () => {
  if (!refreshPromise) {
    const refresh = localStorage.getItem('refresh');
    refreshPromise = (refresh
      ? api.post('/api/token/refresh/', { refresh })
      : Promise.reject(new Error('no refresh token'))
    )
      .then((res) => {
        localStorage.setItem('access', res.data.access);
        window.dispatchEvent(new CustomEvent('auth:refreshed', { detail: res.data.access }));
        return res.data.access;
      })
      .catch((err) => {
        window.dispatchEvent(new Event('auth:logout'));
        throw err;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (
      error.response?.status === 401 &&
      original &&
      !original._retry &&
      !isAuthCall(original.url) &&
      localStorage.getItem('refresh')
    ) {
      original._retry = true;
      try {
        const access = await refreshAccessToken();
        original.headers.Authorization = `Bearer ${access}`;
        return api(original);
      } catch (e) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
